import { NOT_FOUND } from 'http-status-codes';

class FetchingError extends Error {
  constructor(message, status, hasAdditionalInfo) {
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchingError);
    }

    this.isFetchingError = true;
    this.status = status;
    this.hasAdditionalInfo = hasAdditionalInfo;
  }
}

class UnauthorizedError extends Error {
  constructor(message) {
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UnauthorizedError);
    }

    this.isAuthorizationError = true;
  }
}

class ValidationError extends Error {
  constructor(message) {
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }

    this.isValidationError = true;
  }
}

class TimeoutError extends Error {
  constructor() {
    super();

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, TimeoutError);
    }

    this.isTimeoutError = true;
  }
}

class NotFoundError extends Error {
  constructor(message) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NotFoundError);
    }

    this.isNotFoundError = true;
    this.status = NOT_FOUND;
  }
}

export default {
  FetchingError: (message, status, hasAdditionalInfo) => new FetchingError(message, status, hasAdditionalInfo),
  UnauthorizedError: message => new UnauthorizedError(message),
  ValidationError: message => new ValidationError(message),
  TimeoutError: () => new TimeoutError(),
  NotFoundError: message => new NotFoundError(message),
};
